import React, { Component, PropTypes } from 'react';
import ProjectTypeTabs from 'your_projects/containers/project_type_tabs';
import { hasAPIQueryStringChanged } from 'common/utils';
import { LoadingIndicator } from 'common/components/preloader';
import Filter from 'common/filter/containers';
import Pager from 'common/pager/containers';
import { TYPE_CHECKBOXES, TYPE_RANGE } from 'common/filter/constants';
import { PROJECTS_RESOURCE_NAME } from 'your_projects/constants';
import EmptyGallery from 'your_projects/components/empty_gallery';
import Projects from 'your_projects/components/projects';
import Controls from 'your_projects/containers/controls';

export default class Gallery extends Component {
  componentDidMount() {
    this.props.fetch();
  }

  componentDidUpdate(prevProps) {
    /* re-fetch resource if filter/sorting/search/etc query parameters have changed */
    if (hasAPIQueryStringChanged(PROJECTS_RESOURCE_NAME, prevProps, this.props)) {
      this.props.fetch();
    }
  }

  componentWillUnmount() {
    this.props.clear();
  }

  render() {
    const { projects, isFetching, userType, projectType, user } = this.props;

    return (
      <div className="row all-projects-page">
        <div className="small-16 large-12 columns">
          { user.is_client && user.is_creative &&
          <div className="hide-for-large">
            <ProjectTypeTabs />
          </div> }
          <section>
            { isFetching? <LoadingIndicator fullScreen={false} /> :
            <div>
              { projects.length === 0?
              <EmptyGallery userType={userType} projectType={projectType} /> :
              <div>
                <Projects items={projects} userType={userType} projectType={projectType} />
                <Pager resourceName={PROJECTS_RESOURCE_NAME} />
              </div> }
            </div> }
          </section>
        </div>
        <div className="small-16 large-4 columns show-for-large">
          <Controls />
        </div>
      </div>
    );
  }
}

Gallery.propTypes = {
  user: PropTypes.object.isRequired,
  userType: PropTypes.string.isRequired,
  projectType: PropTypes.string.isRequired,
  fetch: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
  projects: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./your_projects/components/gallery.jsx